import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import MultipleMenuSection from '../MultipleMenuSection'

import { getIDs, getNames } from '../../helpers/parse'
import { selectCategory, fetchCategories } from '@SonarCX/slices/category'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'

type CategoryFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const CategoryFilter: React.FC<CategoryFilterProps> = props => {
  const dispatch = useAppDispatch()

  const { categoriesValues, loaded, loading } = useAppSelector(selectCategory)

  const { state, handleChange } = useTaskFilters()

  // Fetch categories if not loaded
  React.useEffect(() => {
    if (!loaded && !loading) {
      dispatch(fetchCategories())
    }
  }, [loaded, loading, dispatch])

  return (
    <MultipleMenuSection
      title='Categories'
      options={getIDs(categoriesValues)}
      value={state.categoryValue}
      setValue={handleChange('categoryValue')}
      transform={getNames(categoriesValues)}
      unassignedOpt='All Categories'
      {...props}
    />
  )
}

export default CategoryFilter
